<div class="manage-wellspace-header">
  <h1>{{ showNativeTeamSettings ? 'Team Settings' : 'Manage Your Wellspace' }}</h1>
  @if (showNativeTeamSettings) {
    <a mat-stroked-button routerLink="/my-team" queryParamsHandling="preserve">
      <mat-icon>arrow_back</mat-icon> Back to My Team
    </a>
  }
  @if (canOpenNewTeamsExperience) {
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="openNewTeamsExperience()"
      >
      <mat-icon>open_in_new</mat-icon>
      Open in new Teams experience
    </button>
  }
</div>
<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a mat-tab-link
      (click)="onLinkClick(link)"
      [disabled]="link.title === 'Plan' && !isApproved"
    [active]="activeLink == link">{{ link.title }}</a>
  }
</nav>
@if (activeLink?.title === 'Overview') {
  <app-teamedit></app-teamedit>
}
@if (activeLink?.title === 'Benefits') {
  <app-team-set-benefits
    (emitHasUnsavedChanges)="setHasUnsavedChanges($event)"
    (emitChangesWereSaved)="setHasUnsavedChanges($event)">
  </app-team-set-benefits>
}
@if (activeLink?.title === 'Members') {
  <app-team-add-members></app-team-add-members>
}
@if (activeLink?.title === 'Products') {
  <app-benefit-flyers [teamId]="activeProductsTeamId"></app-benefit-flyers>
  <app-managewellspace-products [teamId]="activeProductsTeamId" [companyId]="companyId"></app-managewellspace-products>
}
@if (activeLink?.title === 'Rewards history') {
  <app-program></app-program>
}
@if (activeLink?.title === 'Plan') {
  <app-plan></app-plan>
}
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
